export default {
  setSurvey(state, survey) {
    state.survey = survey
  }
}
